import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "grid grid-cols-2 gap-6 mt-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 border-t border-gray-200" }, null, -1)
const _hoisted_4 = { class: "col-span-2" }
const _hoisted_5 = { class: "col-span-2" }
const _hoisted_6 = { class: "col-span-2" }
const _hoisted_7 = { class: "col-span-2 flex items-center" }
const _hoisted_8 = ["innerHTML"]

import { ref } from 'vue';
import SectionTitle from '@/components/partials/SectionTitle.vue';
import TextInput from '@/components/inputs/TextInput.vue';
import CkEditor from '@/components/inputs/CKEditor.vue';
import { ExclamationCircleIcon } from '@heroicons/vue/24/outline';


export default /*#__PURE__*/_defineComponent({
  __name: 'FormSection',
  setup(__props) {

const text = ref<string>('Liquid Variables: {{ personnel_name }} {{ case_number }}');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SectionTitle, {
      fontSmall: "",
      title: "Notification Information",
      description: "Relevant data and other details"
    }),
    _createElementVNode("form", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(TextInput, {
          type: "text",
          label: "Module",
          placeholder: "Module",
          name: "module",
          id: "module"
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(TextInput, {
          type: "text",
          label: "Subject",
          placeholder: "Subject",
          name: "subject",
          id: "subject"
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(CkEditor, { label: "Content" })
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_unref(ExclamationCircleIcon), { class: "w-6 h-6 text-red-600 stroke-2 mr-1" }),
        _createElementVNode("div", {
          class: "font-bold text-sm text-red-600",
          innerHTML: text.value
        }, null, 8, _hoisted_8)
      ]),
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})